export const STATS_BASE_URL = 'ui/organization/stats';
export const PRODUCTS_STATS_BASE_URL = 'ui/organization/stats/products';

export const statsQueryKeys = {
  all: [STATS_BASE_URL],

  products: [PRODUCTS_STATS_BASE_URL, 'products'],
};
